import React, { Component } from 'react';
import { CommonBaseStore, CommonStore } from 'sos-common/js/commonTypes/commonStore.types';
import { getStore } from '../../Redux/store.provider';
import { SaveOrder } from './SaveOrder/SaveOrder';
import { DeleteOrder } from './DeleteOrder/DeleteOrder';

import { deleteAction, saveOrderAction, saveCloseAction } from './eservicemenu.actions';
import './EServiceFormMenu.scss';
import { bindActionCreators } from 'redux';
import { ButtonModal } from 'sos-common/js/components/ButtonModal/ButtonModal';

export interface EServiceFormMenuProps {
  deletePath: string;
  deleteRedirect: string;
}

export interface EServiceFormMenuState {
  deleteDisabled: boolean;
}

export class EServiceFormMenu extends Component<{}, EServiceFormMenuState> {
  private _store: CommonStore;
  private _saveOrder: any;
  private _saveAndClose: any;

  constructor(props: EServiceFormMenuProps) {
    super(props);

    this.state = {
      deleteDisabled: true,
    };
  }

  componentDidMount() {
    getStore((store) => {
      this._store = store;
      this._saveOrder = bindActionCreators(saveOrderAction, store.dispatch);
      this._saveAndClose = bindActionCreators(saveCloseAction, store.dispatch);
      this._store.subscribe(this.onStoreUpdate);
      this.onStoreUpdate();
    });
  }
  onStoreUpdate = () => {
    const state: CommonBaseStore = this._store.getState();
    const deleteDisabled = !(state.globals && state.globals.shouldShowDelete);
    this.setState({
      deleteDisabled,
    });
  };

  //this is called from the deleteorder component after clicking delete
  afterDelete = () => {
    this._store.dispatch(deleteAction());
  };

  save = () => {
    this._saveOrder();
    //this._store.dispatch(saveOrderAction());
  };

  saveAndClose = () => {
    this._saveAndClose();
    //this._store.dispatch(saveCloseAction());
  };

  public render() {
    const { deleteDisabled } = this.state;

    return (
      <div>
        <section className="eservice-navigation" aria-label="Kontroller för formuläret">
          <div className="eservice-navigation__topnav">
            <DeleteOrder
              modalHeading="Delete"
              modalBody="Are you sure?"
              cancelText="Avbryt"
              actionText="Ta bort"
              disabled={deleteDisabled}
              onActionCompleted={this.afterDelete}
            />

            <div className="eservice-navigation__topnav--right">
              <SaveOrder onAction={this.save} buttonCss={'button eservice-navigation__saveorderbtn'} />
              <ButtonModal
                buttonText="Spara och stäng"
                buttonCss="button button--white"
                modalAction=""
                modalHeading="Spara och stäng"
                modalBody="Är du säker på att du vill spara och stänga?"
                modalCancelText="Avbryt"
                modalCancelCss="button button--white"
                modalActionText="Spara och stäng"
                modalActionCss="button"
                modalActionUrl="#"
                callBackLink="#"
                onActionCompleted={this.saveAndClose}
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}
